import { connect } from 'react-redux';
import { shareDeviationToPost } from '../../../redux/deviations/actionCreators';
var mapDispatchToProps = function (dispatch, _a) {
    var deviation = _a.deviation;
    return ({
        shareToPost: function () { return dispatch(shareDeviationToPost(deviation)); },
    });
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=ShareInPost.container.js.map